import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchCountries } from "@/store/modern/slices/countrySlice";

const AppInitializer = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCountries());

    }, [dispatch]);

    return children
}

export default AppInitializer;